import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import intervalPlural from 'i18next-intervalplural-postprocessor';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}.json", // path where resources get loaded from, or a function
      // returning a path:
      // function(lngs, namespaces) { return customPath; }
      // the returned path will interpolate lng, ns if provided like giving a static path
    },
    fallbackLng: "en",
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
    // pluralRules: {
    //   'ru': (count: number) => {
    //     if (count === 1) return 'one';
    //     if (count >= 2 && count <= 4) return 'few';
    //     return 'many';
    //   },
    //   'en': (count: number) => {
    //     if (count === 1) return 'one';
    //     return 'many';
    //   },
    //   'tr': (count: number) => {
    //     if (count === 1) return 'one';
    //     return 'many';
    //   },
    // },
  });

// export default i18n;
